import styled from 'styled-components';

const OverlayImageWrapper = styled.div`
  position: relative;
  margin: 12px auto;

  img {
    display: block;
    object-fit: cover;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, ${(props) => props.opacity || 0.5});
    padding: 8px 28px;
    line-height: 32px;
  }
`;

export default OverlayImageWrapper;
